import { Skeleton } from '@mui/material';
import React from 'react';

export const FieldLoadingCell = ({ label }: { label: string }) => (
  <Skeleton
    role="progressbar"
    aria-label={`Loading ${label}`}
    variant="text"
    width="60%"
    sx={{ fontSize: 'inherit' }}
  />
);
